import { ReactElement, HTMLAttributes } from 'react';
import classNames from 'classnames/bind';
import LeftGroup from './LeftGroup';
import RightGroup from './RightGroup';
import styles from './styles.module.scss';

interface ButtonRowProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactElement | (ReactElement | boolean)[];
  className?: string;
}

const cx = classNames.bind(styles);

const ButtonRow = ({ children, className, ...rest }: ButtonRowProps) => (
  <div {...rest} className={cx(className, { buttonRow: true })}>
    {children}
  </div>
);

ButtonRow.LeftGroup = LeftGroup;
ButtonRow.RightGroup = RightGroup;

export default ButtonRow;
